import React, { useEffect, useMemo, useRef } from 'react';

//* Components
import CollapseItem from '../CollapseItem';

//* Styles
import CollapseContainerStyle from './style';

const CollapseContainer = ({ items = [], children, multiple = true, openType, className, clickable = true }) => {
	//! Refs
	const collapseContainerRef = useRef();
	const prevActive = useRef(null);

	let child = children;

	//! Check disable item
	function haveDisableItem({ activeDisableItem, allDisabledItem, prevActiveRef }) {
		allDisabledItem.forEach((item) => {
			if (activeDisableItem.getAttribute('disable') == 'true') {
				if (item == activeDisableItem) {
					item.setAttribute('status', 'open');
					item.classList.add('after-disable', 'active');
					item.classList.remove('disable');
					prevActiveRef.current = item;
				} else {
					item.setAttribute('status', 'close');
					item.classList.add('disable');
					item.classList.remove('active');
				}
			} else {
				if (item != activeDisableItem) {
					item.classList.remove('disable');
				} else {
					activeDisableItem.classList.remove('after-disable');
				}
			}
		});
	}

	//! Status disabled all other item
	useEffect(() => {
		if (collapseContainerRef.current) {
			const childrenCollapse = collapseContainerRef.current.querySelectorAll('#collapse-item');
			const itemDisable = [...childrenCollapse].filter((item) => item.getAttribute('disable'));

			//! If multiple and first open-item
			if (multiple) {
				const itemStatusOpen = [...childrenCollapse].filter((item) => item.getAttribute('status') == 'open');
				prevActive.current = itemStatusOpen[0];
			}

			//! Disable status
			if (itemDisable.length) {
				const activeDisable = itemDisable.filter((item) => item.getAttribute('disable') == 'true');

				if (activeDisable.length) {
					haveDisableItem({ activeDisableItem: activeDisable[0], allDisabledItem: itemDisable, prevActiveRef: prevActive });
				}

				//! Disable status watches live-mutation
				itemDisable.forEach((item) => {
					const observer = new MutationObserver((mutationsList) => {
						mutationsList.forEach((mutation) => {
							if (mutation.type === 'attributes' && mutation.attributeName == 'disable' && mutation.target) {
								haveDisableItem({ activeDisableItem: mutation.target, allDisabledItem: itemDisable, prevActiveRef: prevActive });
							}
						});
					});

					const config = { attributes: true };

					observer.observe(item, config);
				});
			}
		}
	}, []);

	//! Open-close
	function collapseClick(ev) {
		const itemElement = ev.target.closest('#collapse-item');
		const openCloseButton = openType == 'button' ? ev.target.closest('#open-close-button') : clickable ? ev.target.closest('#collapse-item') : ev.target.closest('#collapse-title');

		if (itemElement && openCloseButton) {
			const statusItem = itemElement.getAttribute('status');
			const prevStatus = prevActive.current ? prevActive.current.getAttribute('status') : null;
			const disabledElement = itemElement.getAttribute('disable');

			if (disabledElement !== 'true') {
				if (prevActive.current && prevStatus == 'open' && multiple) {
					prevActive.current.classList.remove('active');
					prevActive.current.setAttribute('status', 'close');

					openType == 'button' ? prevActive.current.querySelector('#open-close-button')?.children[0]?.classList.remove('active') : null;
					prevActive.current = null;
				}

				if (statusItem && statusItem == 'close') {
					itemElement.classList.add('active');
					itemElement.setAttribute('status', 'open');

					openType == 'button' ? openCloseButton.children[0]?.classList.add('active') : null;
					prevActive.current = itemElement;
				} else {
					itemElement.setAttribute('status', 'close');
					itemElement.classList.remove('active');

					openType == 'button' ? openCloseButton.children[0]?.classList.remove('active') : null;
					prevActive.current = null;
				}
			}
		}
	}

	// TODO: need testing
	if (items.length) {
		child = useMemo(() => items.map((item) => <CollapseItem {...item} />), [items]);
	}

	return (
		<CollapseContainerStyle
			onClick={collapseClick}
			id={'collapse-container'}
			ref={collapseContainerRef}
			className={`${className || ''} ${openType == 'button' ? '' : clickable ? 'clickable-all' : 'clickable-title'}`}>
			{child}
		</CollapseContainerStyle>
	);
};

export default CollapseContainer;
